import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import rolodexLogo from './assets/rolodex.webp';
import { api } from './api';

function Register() {
  const navigate = useNavigate();
  const [form, setForm] = React.useState({ email: '', username: '', password: '', confirmPassword: '' });
  const [error, setError] = React.useState('');
  const [saving, setSaving] = React.useState(false);

  const submit = async event => {
    event.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setSaving(true);
    try {
      await api.post('/v1/auth/register', { email: form.email, username: form.username, password: form.password });
      navigate('/login');
    } catch (err) {
      setError(err?.response?.data || 'Unable to create account.');
    } finally {
      setSaving(false);
    }
  };

  const update = field => event => setForm(current => ({ ...current, [field]: event.target.value }));
  const inputStyle = { padding: '0.75rem', border: '1px solid #ddd', borderRadius: '5px', fontSize: '1rem', background: '#fafafa', outline: 'none' };

  return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', gap: 50 }}>
    <div><img src={rolodexLogo} alt="Digidex Logo" style={{ height: '7.5rem', width: '7.5rem', objectFit: 'contain' }} /><h1 style={{ fontSize: '2.15rem', fontWeight: 'bold', color: '#333' }}>Digidex</h1></div>
    <form onSubmit={submit} style={{ background: '#fff', padding: '2rem 2.5rem', borderRadius: '10px', boxShadow: '0 2px 16px rgba(0,0,0,0.07)', minWidth: '320px', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '1rem', color: '#222' }}>Create Account</h2>
      {error && <div style={{ color: '#b00020', textAlign: 'center' }}>{error}</div>}
      <input placeholder="Email" type="email" value={form.email} onChange={update('email')} required style={inputStyle} />
      <input placeholder="Username" value={form.username} onChange={update('username')} required style={inputStyle} />
      <input placeholder="Password" type="password" value={form.password} onChange={update('password')} required minLength={8} style={inputStyle} />
      <input placeholder="Confirm password" type="password" value={form.confirmPassword} onChange={update('confirmPassword')} required minLength={8} style={inputStyle} />
      <button type="submit" disabled={saving} style={{ padding: '0.75rem', border: 'none', borderRadius: '5px', background: '#222', color: '#fff', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', marginTop: '0.5rem' }}>{saving ? 'Creating…' : 'Create Account'}</button>
      <Link to="/login" style={{ textAlign: 'center', color: '#222', fontWeight: 'bold' }}>Already have an account? Log in</Link>
    </form>
  </div>;
}

export default Register;
